module.exports = __webpack_public_path__ + "img/T1D_rc-5.afb95b8e.png";